/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

/**
 * Every app-level path, once.
 *
 * Sidebar, search, the assistant, the landing page and the router itself used to
 * each keep their own copy of these strings, so renaming a route meant finding
 * all of them. Import from here instead — see docs/CONVENTIONS.md §1.5.
 *
 * Feature-internal paths (a detail page, a compare view) live in that feature's
 * own module and derive their base from here: a dual-mounted feature also needs
 * `basePath()` to keep links on the mount the visitor is already on, which is
 * feature-specific logic and does not belong in this table.
 */

const DEV = "/services/developer";

export const ROUTES = {
  // Public site
  home: "/",
  publicHome: "/public",
  training: "/training",

  // Account
  profile: "/profile",
  plans: "/plansServices",
  plansBilling: "/plansServices/billing",
  plansUsage: "/plansServices/usage",
  helpAndSupport: "/help-and-support",

  // Developer app
  services: "/services",
  developer: DEV,
  dashboard: `${DEV}/dashboard`,
  overview: `${DEV}/overview`,
  docs: `${DEV}/docspage`,
  downloads: `${DEV}/downloads`,
  protectedDownloads: `${DEV}/protected-downloads`,
  devices: `${DEV}/devices`,
  remoteSSH: `${DEV}/remoteSSH`,
  thrustStand: `${DEV}/thrust-stand`,
  logAnalyzer: `${DEV}/log-analyzer`,
  propulsionCalc: `${DEV}/propulsion-calculator`,
  motorData: `${DEV}/motor-data`,
  firmwareFlasher: `${DEV}/firmware-flasher`,
};

/** Paths that render the public developer landing instead of bouncing to login. */
export const LANDING_PATHS = [ROUTES.home, ROUTES.services, ROUTES.developer];

/**
 * Is this path on a public (`<feature>/public`) mount?
 *
 * A feature's own links use its `basePath()`, which compares against that
 * feature's base. This is for links that cross features — motor-data offering
 * the propulsion calculator, say — where the visitor's mount has to be read
 * from a path belonging to a different feature entirely. Getting it wrong
 * throws an anonymous visitor into the protected tree, or kicks a signed-in one
 * out of the app shell.
 */
export const isPublicMount = (pathname = window.location.pathname) =>
  /^\/services\/developer\/[^/]+\/public(\/|$)/.test(pathname);

export const devicePath = (id) => `${ROUTES.devices}/${id}`;
export const deviceRemoteSSHPath = (id) => `${ROUTES.devices}/${id}/remoteSSH`;
